import { Contract } from 'cpnl-common';
import React from 'react';

type ContractSelectItemProps = {
    contract: Contract;
};

export const ContractSelectItem: React.FC<ContractSelectItemProps> = ({ contract }) => (
    <div className="u-block">
        <p className="u-mb-none">
            <strong>{contract.contractNumber}</strong>
        </p>
        <p className="u-mb-none">
            <strong>{contract.productType}</strong>
        </p>
        {`${contract.carBrand || ''} ${contract.carModel || ''}${
            contract.licensePlate ? `, ${contract.licensePlate}` : ''
        }`}
    </div>
);
